import React from "react";

export const useTimeout = (callback: Function, delay: number) => {
  const callbackRef = React.useRef<Function | null>(null);
  const timeoutIdRef = React.useRef<number | null>(null);

  if (!callbackRef.current) {
    callbackRef.current = callback;
  }

  const call = React.useCallback(() => {
    if (!timeoutIdRef.current) {
      timeoutIdRef.current = window.setTimeout(() => {
        callbackRef.current && callbackRef.current();
        timeoutIdRef.current = null;
      }, delay);
    }
  }, [delay]);

  const cancel = React.useCallback(() => {
    if (timeoutIdRef.current) {
      window.clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
  }, []);

  return { call, cancel };
};

export default useTimeout;
